<app-navigation-bar></app-navigation-bar>
<div class="parent">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <!-- table dynamic columns -->
    <ng-container
      *ngFor="let column of columns"
      [matColumnDef]="column.columnDef"
    >
      <th class="center-cell" mat-header-cell *matHeaderCellDef>
        {{ column.header }}
      </th>
      <td
        class="center-cell"
        [ngClass]="{
          cross:
            column.type !== 'field' &&
            crossRound(row.roundResults, column.columnDef)
        }"
        mat-cell
        *matCellDef="let row"
      >
        {{
          column.type === "field"
            ? row[column.columnDef]
            : row.roundResults[column.columnDef].championshipPoints
        }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
